angular.module('unica_media.media_services')

.factory('MediaEditService', function ($http, getBaseApiURL, getBaseWebURL) {

	var mediaEditService = {};

	mediaEditService.updateStatus = function (id, mediaData)
	{
		return $http({
			method: 'POST',
			url: getBaseApiURL + '/media/update-status/' + id,
			data: mediaData
		}).then(function(result) {

			if ( result ) {
				return result.data.media;
			}

		});
	};

	mediaEditService.addDownload = function (id)
	{
		return $http({
			method: 'GET',
			url: getBaseWebURL + '/media/add-download/' + id,
			data: {}
		}).then(function(result) {

			if ( result ) {
				return true;
			}

		});
	};


	return mediaEditService;
});